import React, { useEffect, useRef, useState } from 'react';
import 'leaflet/dist/leaflet.css';

const TrailMap = ({ trackCoordinates, startLat, startLng, endLat, endLng, name }) => {
  const mapContainerId = useRef(`map-${Math.random().toString(36).slice(2)}`);
  const [mapReady, setMapReady] = useState(false);

  useEffect(() => {
    let map = null;

    const initMap = async () => {
      const L = (await import('leaflet')).default;

      const container = document.getElementById(mapContainerId.current);
      if (!container || container._leaflet_id) return;

      // Fix default marker icons
      delete L.Icon.Default.prototype._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
        iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
      });

      map = L.map(container, {
        zoomControl: true,
        scrollWheelZoom: false,
      });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap',
        maxZoom: 18,
      }).addTo(map);

      if (trackCoordinates && trackCoordinates.length > 1) {
        const latLngs = trackCoordinates.map(c => [c[1], c[0]]);
        const polyline = L.polyline(latLngs, {
          color: '#38B2AC',
          weight: 4,
          opacity: 0.9,
        }).addTo(map);

        // Start marker
        const startIcon = L.divIcon({
          className: '',
          html: '<div style="width:14px;height:14px;border-radius:50%;background:#319795;border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.3)"></div>',
          iconSize: [14, 14],
          iconAnchor: [7, 7],
        });
        L.marker(latLngs[0], { icon: startIcon }).addTo(map).bindPopup('Inicio');

        // End marker if linear
        const lastPoint = latLngs[latLngs.length - 1];
        const dist = Math.abs(latLngs[0][0] - lastPoint[0]) + Math.abs(latLngs[0][1] - lastPoint[1]);
        if (dist > 0.001) {
          const endIcon = L.divIcon({
            className: '',
            html: '<div style="width:14px;height:14px;border-radius:50%;background:#EF4444;border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.3)"></div>',
            iconSize: [14, 14],
            iconAnchor: [7, 7],
          });
          L.marker(lastPoint, { icon: endIcon }).addTo(map).bindPopup('Final');
        }

        map.fitBounds(polyline.getBounds(), { padding: [30, 30] });
      } else if (startLat && startLng) {
        map.setView([startLat, startLng], 14);
        L.marker([startLat, startLng]).addTo(map).bindPopup(name || 'Inicio');
      }

      setMapReady(true);
    };

    const timer = setTimeout(initMap, 100);

    return () => {
      clearTimeout(timer);
      if (map) {
        map.remove();
        map = null;
      }
    };
    // El mapa Leaflet se inicializa una sola vez; los props no cambian durante la vida del componente
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id={mapContainerId.current}
      className="w-full h-[250px] rounded-xl overflow-hidden"
      style={{ zIndex: 0 }}
      data-testid="trail-map"
    />
  );
};

export default TrailMap;
